import { useNavigate } from 'react-router-dom'
import logo from '../../assets/logo.svg'
import './StaticPage.css'
import { PwaUpdateBanner } from '../components/PwaUpdateBanner'

export function About() {
  const navigate = useNavigate()

  return (
    <div className="static-page">
      <header className="static-header">
        <div className="static-header-content">
          <img 
            src={logo} 
            alt="Ordelio Logo" 
            className="static-logo clickable" 
            onClick={() => navigate('/')}
          />
          <button onClick={() => navigate('/')} className="back-to-home-btn">
            ← Back to Home
          </button>
        </div>
      </header>

      <PwaUpdateBanner />

      <main className="static-content">
        <article className="content-container">
          <h1>About Ordelio</h1>
          
          <section className="content-section">
            <h2>Our Mission</h2>
            <p>
              Ordelio was created to solve a common problem: lists that are disorganized,
              hard to reuse, and unreliable when you’re offline. We believe planning should
              feel calm, predictable, and easy to repeat—whether it’s your usual shop, a set of errands,
              or a travel checklist.
            </p>
          </section>

          <section className="content-section">
            <h2>What Makes Ordelio Different</h2>
            <p>
              Unlike traditional shopping list apps, Ordelio focuses on the features that matter most:
            </p>
            <ul>
              <li><strong>Offline-First Design:</strong> Your lists work everywhere, even without internet</li>
              <li><strong>Online Collaboration:</strong> When connected, share lists and see updates from family members</li>
              <li><strong>Item History:</strong> Quickly rebuild lists from items you've used before</li>
              <li><strong>Custom Store Routes:</strong> Organize items to match your store's layout</li>
              <li><strong>Multi-Device Sync:</strong> Access your lists from any device when online</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>Built for Real People</h2>
            <p>
              Whether you’re planning weekly grocery runs, coordinating household shopping,
              managing multiple store visits, or keeping a repeatable packing list, Ordelio adapts to your needs.
              We focus on practical features that help you follow the same flow each time.
            </p>
          </section>

          <section className="content-section">
            <h2>Technology & Privacy</h2>
            <p>
              Ordelio is built with modern web technologies and follows industry-standard security practices. 
              We use secure authentication and encrypt all data in transit and at rest. Your privacy is our 
              priority—we only store the information necessary for the app to function.
            </p>
          </section>

          <section className="content-section">
            <h2>Continuous Improvement</h2>
            <p>
              We’re constantly improving Ordelio based on user feedback.
              If there’s something that would make your routine easier—especially around reuse, ordering, or collaboration—let us know.
            </p>
          </section>

          <div className="cta-container">
            <button onClick={() => navigate('/')} className="cta-button">
              Try Ordelio Today
            </button>
          </div>
        </article>
      </main>

      <footer className="static-footer">
        <p>© 2026 Ordelio. All rights reserved.</p>
      </footer>
    </div>
  )
}
